import { render, staticRenderFns } from "./EatingExperiencePagination.vue?vue&type=template&id=061b11a2&"
import script from "./EatingExperiencePagination.vue?vue&type=script&lang=js&"
export * from "./EatingExperiencePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports